import { generatePath } from "react-router-dom";
import {
  CLONE_TEMPLATE_BY_ID,
  TEMPLATES,
  TEMPLATE_BY_ID,
} from "../apiEndPoints";
import { api, convertKeysToCamelCase, convertKeysToSnakeCase } from "./api";

export const templateApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    createTemplate: builder.mutation({
      query: ({ accountId, ...rest }) => {
        const { autoTime1, autoTime2, ...restWithoutTimes } = rest;
        const body = {
          ...convertKeysToSnakeCase(restWithoutTimes),
          ...(autoTime1 !== undefined && { auto_time1: autoTime1 }),
          ...(autoTime2 !== undefined && { auto_time2: autoTime2 }),
        };

        return {
          url: generatePath(TEMPLATES, { accountId }),
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Templates"],
    }),
    getTemplates: builder.query({
      query: ({
        accountId,
        offset,
        limit,
        search,
        showAutoEnabled,
        accountTagIds,
        includeTotalCount,
      }) => {
        const baseUrl = generatePath(TEMPLATES, { accountId });
        const queryParams = new URLSearchParams({
          offset: String(offset),
          limit: String(limit),
          include_total_count: String(includeTotalCount),
        });
        if (search) {
          queryParams.append("search", search);
        }
        if (accountTagIds?.length) {
          accountTagIds.forEach((id: string) =>
            queryParams.append("account_tag_ids", id)
          );
        }
        if (showAutoEnabled !== null && showAutoEnabled !== undefined) {
          queryParams.append("show_auto_enabled", showAutoEnabled);
        }
        return {
          url: `${baseUrl}?${queryParams.toString()}`,
          method: "GET",
        };
      },
      transformResponse: (response) => convertKeysToCamelCase(response),
      providesTags: (result, error, { accountId }) => [
        { type: "Templates", accountId },
      ],
    }),
    getTemplate: builder.query({
      query: ({ accountId, templateId }) => ({
        url: generatePath(TEMPLATE_BY_ID, {
          accountId,
          templateId,
        }),
        method: "GET",
      }),
      transformResponse: (response) => convertKeysToCamelCase(response),
      providesTags: (result, error, { accountId }) => [
        { type: "Templates", accountId },
      ],
    }),
    updateTemplate: builder.mutation({
      query: ({ accountId, templateId, autoTime1, autoTime2, ...rest }) => {
        const body = {
          ...convertKeysToSnakeCase(rest),
          ...(autoTime1 !== undefined && { auto_time1: autoTime1 }),
          ...(autoTime2 !== undefined && { auto_time2: autoTime2 }),
        };

        return {
          url: generatePath(TEMPLATE_BY_ID, {
            accountId,
            templateId,
          }),
          method: "PATCH",
          body,
        };
      },
      invalidatesTags: ["Templates"],
    }),
    cloneTemplate: builder.mutation({
      query: ({ accountId, templateId, autoTime1, autoTime2, ...rest }) => {
        const body = {
          ...convertKeysToSnakeCase(rest),
          ...(autoTime1 !== undefined && { auto_time1: autoTime1 }),
          ...(autoTime2 !== undefined && { auto_time2: autoTime2 }),
        };

        return {
          url: generatePath(CLONE_TEMPLATE_BY_ID, {
            accountId,
            templateId,
          }),
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Templates"],
    }),
    deleteTemplate: builder.mutation({
      query: ({ accountId, templateId }) => ({
        url: generatePath(TEMPLATE_BY_ID, {
          accountId,
          templateId,
        }),
        method: "DELETE",
      }),
      invalidatesTags: ["Templates"],
    }),
  }),
});

export const {
  useGetTemplatesQuery,
  useGetTemplateQuery,
  useCreateTemplateMutation,
  useUpdateTemplateMutation,
  useDeleteTemplateMutation,
  useCloneTemplateMutation,
} = templateApiSlice;
